import { render, staticRenderFns } from "./design-table.vue?vue&type=template&id=215b72c0&scoped=true"
import script from "./design-table.vue?vue&type=script&lang=js"
export * from "./design-table.vue?vue&type=script&lang=js"
import style0 from "./design-table.vue?vue&type=style&index=0&id=215b72c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215b72c0",
  null
  
)

export default component.exports